import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const GetAllRoles = async (data) => {
    const user = useAuth()
    const url = APIURL + "/admin/viewrole"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default GetAllRoles